// Detailed egg recipes
export const recipes = [
  {
    id: 1,
    title: "Classic Deviled Eggs",
    slug: "classic-deviled-eggs",
    description: "A timeless appetizer perfect for any gathering. These deviled eggs feature a creamy, tangy filling that everyone will love.",
    image: "https://images.pexels.com/photos/916904/pexels-photo-916904.jpeg",
    prepTime: "15 mins",
    cookTime: "12 mins",
    servings: 12,
    ingredients: [
      "6 large eggs",
      "1/4 cup mayonnaise",
      "1 teaspoon Dijon mustard",
      "1 teaspoon white vinegar",
      "Salt and pepper to taste",
      "Paprika for garnish",
      "Fresh chives, chopped (optional)"
    ],
    instructions: [
      "Place eggs in a single layer in a saucepan and cover with water to 1 inch above eggs.",
      "Bring water to a boil, then reduce heat and simmer for 12 minutes for hard-boiled eggs.",
      "Drain and cool eggs in ice water for 5 minutes before peeling.",
      "Cut eggs in half lengthwise and remove yolks to a bowl.",
      "Mash yolks with mayonnaise, mustard, vinegar, salt, and pepper until smooth.",
      "Spoon or pipe the filling back into the egg whites.",
      "Sprinkle with paprika and garnish with chives if desired."
    ],
    tips: "For easier peeling, use eggs that are 7-10 days old rather than very fresh eggs.",
    keywords: ["deviled eggs", "egg appetizer", "classic egg recipe", "party food", "appetizer"],
    amazonProducts: [
      {
        title: "Deviled Egg Platters and Carriers",
        description: "Find the perfect platter for serving and transporting your deviled eggs",
        link: "https://www.amazon.com/s?k=Deviled+Egg+Platter+Carrier+Container"
      },
      {
        title: "Piping Bags and Tips Set",
        description: "Professional piping tools for perfectly filled deviled eggs",
        link: "https://www.amazon.com/s?k=Professional+Piping+Bags+Tips+Set"
      },
      {
        title: "Electric Egg Cookers",
        description: "Automatic egg cookers for perfect hard-boiled eggs",
        link: "https://www.amazon.com/s?k=Electric+Egg+Cooker+Boiler"
      }
    ]
  },
  {
    id: 2,
    title: "Perfect Eggs Benedict",
    slug: "perfect-eggs-benedict",
    description: "Learn to make restaurant-quality Eggs Benedict with perfectly poached eggs and homemade hollandaise sauce.",
    image: "https://images.pexels.com/photos/7663367/pexels-photo-7663367.jpeg",
    prepTime: "20 mins",
    cookTime: "15 mins",
    servings: 4,
    ingredients: [
      "8 large eggs (for poaching)",
      "4 English muffins, split and toasted",
      "8 slices Canadian bacon or ham",
      "2 tablespoons white vinegar",
      "For the hollandaise sauce:",
      "3 large egg yolks",
      "1 tablespoon lemon juice",
      "1/2 cup unsalted butter, melted",
      "Pinch of cayenne pepper",
      "Salt to taste",
      "Fresh chives or parsley for garnish"
    ],
    instructions: [
      "For the hollandaise sauce: Whisk egg yolks and lemon juice in a stainless steel bowl.",
      "Place the bowl over a saucepan with simmering water (double boiler) and whisk constantly.",
      "Slowly drizzle in melted butter while continuing to whisk until sauce thickens.",
      "Remove from heat and add cayenne and salt. Cover and keep warm.",
      "For poached eggs: Fill a large pan with water and add vinegar. Bring to a gentle simmer.",
      "Crack each egg into a small cup, then gently slide into the simmering water.",
      "Cook for 3-4 minutes until whites are set but yolks are still soft.",
      "Remove with a slotted spoon and place on a paper towel to drain.",
      "Assemble: Place toasted English muffin halves on plates, top each with a slice of Canadian bacon.",
      "Place a poached egg on each and drizzle with hollandaise sauce.",
      "Sprinkle with chives or parsley and serve immediately."
    ],
    tips: "The key to perfect hollandaise is constant whisking and careful temperature control - don't let it get too hot or the eggs will scramble.",
    keywords: ["eggs benedict", "breakfast recipe", "brunch", "poached eggs", "hollandaise sauce"],
    amazonProducts: [
      {
        title: "Double Boiler Sets",
        description: "Essential for making perfect hollandaise sauce",
        link: "https://www.amazon.com/s?k=Double+Boiler+Pot+Set+Stainless+Steel"
      },
      {
        title: "Egg Poaching Tools",
        description: "Professional tools for perfect poached eggs",
        link: "https://www.amazon.com/s?k=Professional+Egg+Poacher+Cups+Set"
      },
      {
        title: "Professional Whisks",
        description: "High-quality whisks for smooth hollandaise sauce",
        link: "https://www.amazon.com/s?k=Professional+Kitchen+Whisk+Set+Stainless+Steel"
      }
    ]
  },
  {
    id: 3,
    title: "Fluffy Scrambled Eggs",
    slug: "fluffy-scrambled-eggs",
    description: "The secret to making the fluffiest, creamiest scrambled eggs perfect for a satisfying breakfast.",
    image: "https://images.pexels.com/photos/2739268/pexels-photo-2739268.jpeg",
    prepTime: "5 mins",
    cookTime: "5 mins",
    servings: 2,
    ingredients: [
      "4 large eggs",
      "2 tablespoons milk or heavy cream",
      "1 tablespoon butter",
      "Salt and freshly ground pepper to taste",
      "Fresh chives or herbs (optional)",
      "Grated cheese (optional)"
    ],
    instructions: [
      "Crack eggs into a bowl and add milk or cream.",
      "Whisk gently until just combined - don't overwhisk.",
      "Melt butter in a non-stick pan over medium-low heat.",
      "Pour in egg mixture and let sit undisturbed for about 20 seconds.",
      "Using a silicone spatula, gently fold the eggs from the edges toward the center.",
      "Continue folding the eggs every few seconds, forming soft curds.",
      "Remove from heat when eggs are still slightly wet - they'll continue cooking from residual heat.",
      "Season with salt and pepper and add optional herbs or cheese.",
      "Serve immediately on warm toast or with breakfast sides."
    ],
    tips: "The key to fluffy scrambled eggs is low heat and gentle, infrequent stirring. Never use high heat as it makes eggs tough and dry.",
    keywords: ["scrambled eggs", "breakfast eggs", "fluffy eggs", "creamy eggs", "egg recipes"],
    amazonProducts: [
      {
        title: "Non-Stick Frying Pans",
        description: "Perfect pans for scrambled eggs",
        link: "https://www.amazon.com/s?k=Non+Stick+Frying+Pan+Eggs"
      },
      {
        title: "Silicone Spatula Sets",
        description: "Essential tools for perfect scrambled eggs",
        link: "https://www.amazon.com/s?k=Silicone+Spatula+Set+Heat+Resistant"
      },
      {
        title: "Mixing Bowl Sets",
        description: "Quality bowls for egg preparation",
        link: "https://www.amazon.com/s?k=Glass+Mixing+Bowls+Set+Kitchen"
      }
    ]
  },
  {
    id: 4,
    title: "Perfect French Omelette",
    slug: "perfect-french-omelette",
    description: "Master the classic French omelette - delicate, soft, and folded to perfection with a creamy interior.",
    image: "https://images.pexels.com/photos/1437268/pexels-photo-1437268.jpeg",
    prepTime: "5 mins",
    cookTime: "3 mins",
    servings: 1,
    ingredients: [
      "3 large eggs",
      "1 tablespoon unsalted butter",
      "1 tablespoon fresh herbs (chives, parsley, tarragon)",
      "Salt and freshly ground pepper",
      "Optional fillings: grated cheese, sautéed mushrooms, or ham"
    ],
    instructions: [
      "Crack eggs into a bowl and beat lightly with a fork just until combined.",
      "Season with salt and pepper.",
      "Heat a non-stick skillet over medium-high heat.",
      "Add butter and swirl to coat the pan as it foams.",
      "Pour in eggs and immediately start stirring with a fork or spatula.",
      "As eggs begin to set (about 30 seconds), stop stirring and shake pan to settle any liquid eggs.",
      "When eggs are mostly set but still slightly wet on top, add optional fillings to one side.",
      "Using a spatula, fold omelette in thirds like a letter.",
      "Slide onto a warm plate seam-side down and garnish with herbs."
    ],
    tips: "The entire cooking process should take less than 2 minutes. For a classic French omelette, the exterior should be smooth without browning, and the interior should be soft and slightly creamy.",
    keywords: ["french omelette", "omelet recipe", "egg breakfast", "gourmet eggs", "classic omelette"],
    amazonProducts: [
      {
        title: "Omelette Pans",
        description: "Professional pans for perfect omelettes",
        link: "https://www.amazon.com/s?k=Professional+Omelette+Pan+Non+Stick"
      },
      {
        title: "Flexible Spatulas",
        description: "Ideal tools for folding omelettes",
        link: "https://www.amazon.com/s?k=Flexible+Spatula+Omelette+Professional"
      },
      {
        title: "Herb Scissors",
        description: "For perfectly cut fresh herbs",
        link: "https://www.amazon.com/s?k=Kitchen+Herb+Scissors+Multi+Blade"
      }
    ]
  },
  {
    id: 5,
    title: "Classic Egg Salad",
    slug: "classic-egg-salad",
    description: "A versatile egg salad perfect for sandwiches, wraps, or on a bed of lettuce for a light lunch.",
    image: "https://images.pexels.com/photos/30855418/pexels-photo-30855418.jpeg",
    prepTime: "10 mins",
    cookTime: "12 mins",
    servings: 4,
    ingredients: [
      "8 large eggs",
      "1/3 cup mayonnaise",
      "1 tablespoon Dijon mustard",
      "1/4 cup finely diced celery",
      "2 tablespoons finely chopped red onion or green onions",
      "1 tablespoon fresh dill or parsley, chopped",
      "1 teaspoon fresh lemon juice",
      "Salt and freshly ground pepper to taste",
      "Paprika for garnish (optional)"
    ],
    instructions: [
      "Place eggs in a saucepan and cover with cold water by 1 inch.",
      "Bring to a boil, then reduce heat to low and simmer for 12 minutes.",
      "Drain and transfer eggs to an ice bath to cool for 5 minutes before peeling.",
      "Chop the eggs and place in a medium bowl.",
      "Add mayonnaise, mustard, celery, onion, herbs, and lemon juice.",
      "Gently fold together until well combined.",
      "Season with salt and pepper to taste.",
      "Cover and refrigerate for at least 30 minutes to allow flavors to blend.",
      "Serve on bread, croissants, or over lettuce, sprinkled with paprika if desired."
    ],
    tips: "For best texture, chop some eggs finely and some more coarsely. For lighter egg salad, replace half the mayonnaise with Greek yogurt.",
    keywords: ["egg salad", "sandwich filling", "egg recipes", "lunch recipe", "picnic food"],
    amazonProducts: [
      {
        title: "Egg Slicers and Choppers",
        description: "Tools for perfect egg salad preparation",
        link: "https://www.amazon.com/s?k=Egg+Slicer+Chopper+Kitchen+Tool"
      },
      {
        title: "Food Storage Containers",
        description: "Quality containers for storing egg salad",
        link: "https://www.amazon.com/s?k=Glass+Food+Storage+Containers+Set"
      },
      {
        title: "Herb Chopping Tools",
        description: "Efficient tools for chopping herbs",
        link: "https://www.amazon.com/s?k=Herb+Chopper+Mezzaluna+Knife"
      }
    ]
  },
  {
    id: 6,
    title: "Spanish Tortilla (Potato Omelette)",
    slug: "spanish-tortilla",
    description: "A classic Spanish dish featuring eggs and potatoes that can be served hot or cold, perfect for any meal of the day.",
    image: "https://images.pexels.com/photos/14941247/pexels-photo-14941247.jpeg",
    prepTime: "15 mins",
    cookTime: "30 mins",
    servings: 6,
    ingredients: [
      "6 large eggs",
      "2 medium potatoes, peeled and thinly sliced",
      "1 medium onion, thinly sliced",
      "1 cup olive oil (for frying potatoes)",
      "Salt and freshly ground pepper",
      "Fresh parsley for garnish (optional)"
    ],
    instructions: [
      "Heat olive oil in a large non-stick skillet over medium heat.",
      "Add potato and onion slices, season with salt, and cook slowly, turning occasionally until potatoes are tender but not browned (about 15 minutes).",
      "Drain the potato and onion mixture in a colander, reserving 2 tablespoons of oil.",
      "In a large bowl, beat eggs lightly and season with salt and pepper.",
      "Add the potato and onion mixture to the eggs and gently combine.",
      "Heat the reserved oil in the skillet over medium heat.",
      "Pour in the egg mixture and cook for about 5-6 minutes until the bottom is set.",
      "Place a large plate over the skillet and carefully flip the tortilla onto the plate.",
      "Slide the tortilla back into the skillet with the uncooked side down.",
      "Cook for another 3-4 minutes until fully set but still moist in the center.",
      "Slide onto a serving plate and let cool slightly before slicing.",
      "Garnish with parsley if desired and serve warm or at room temperature."
    ],
    tips: "The key to a good Spanish tortilla is cooking the potatoes slowly in olive oil until tender but not browned. This gives them a melt-in-your-mouth texture in the finished dish.",
    keywords: ["spanish tortilla", "potato omelette", "spanish cuisine", "tapas", "egg recipes"],
    amazonProducts: [
      {
        title: "Spanish Tortilla Pans",
        description: "Traditional pans for Spanish tortilla",
        link: "https://www.amazon.com/s?k=Spanish+Tortilla+Pan+Non+Stick"
      },
      {
        title: "Mandoline Slicers",
        description: "For perfectly sliced potatoes",
        link: "https://www.amazon.com/s?k=Mandoline+Slicer+Professional+Kitchen"
      },
      {
        title: "Premium Olive Oil Dispensers",
        description: "For precise olive oil pouring",
        link: "https://www.amazon.com/s?k=Olive+Oil+Dispenser+Glass+Bottle"
      }
    ]
  },
  {
    id: 7,
    title: "Eggs Florentine",
    slug: "eggs-florentine",
    description: "A delicious vegetarian breakfast dish featuring poached eggs on a bed of sautéed spinach, topped with hollandaise sauce.",
    image: "https://images.pexels.com/photos/4869431/pexels-photo-4869431.jpeg",
    prepTime: "15 mins",
    cookTime: "15 mins",
    servings: 4,
    ingredients: [
      "8 large eggs (for poaching)",
      "4 English muffins, split and toasted",
      "2 tablespoons white vinegar (for poaching)",
      "1 lb fresh spinach, washed",
      "2 cloves garlic, minced",
      "2 tablespoons olive oil",
      "Salt and freshly ground pepper",
      "Pinch of nutmeg",
      "For the hollandaise sauce:",
      "3 large egg yolks",
      "1 tablespoon lemon juice",
      "1/2 cup unsalted butter, melted",
      "Pinch of cayenne pepper",
      "Salt to taste"
    ],
    instructions: [
      "For the hollandaise sauce: Whisk egg yolks and lemon juice in a stainless steel bowl.",
      "Place the bowl over a saucepan with simmering water (double boiler) and whisk constantly.",
      "Slowly drizzle in melted butter while continuing to whisk until sauce thickens.",
      "Remove from heat, add cayenne and salt. Cover and keep warm.",
      "For the spinach: Heat olive oil in a large skillet over medium heat.",
      "Add minced garlic and sauté for 30 seconds until fragrant.",
      "Add spinach and cook, stirring frequently, until wilted (about 2-3 minutes).",
      "Season with salt, pepper, and nutmeg. Drain excess liquid and keep warm.",
      "For poached eggs: Fill a large pan with water and add vinegar. Bring to a gentle simmer.",
      "Crack each egg into a small cup, then gently slide into the simmering water.",
      "Cook for 3-4 minutes until whites are set but yolks are still soft.",
      "Remove with a slotted spoon and place on a paper towel to drain.",
      "Assemble: Place toasted English muffin halves on plates, top each with sautéed spinach.",
      "Place a poached egg on each and drizzle with hollandaise sauce.",
      "Serve immediately."
    ],
    tips: "Squeezing out excess moisture from the cooked spinach is crucial to prevent soggy muffins. For a richer flavor, add a little butter to the spinach after cooking.",
    keywords: ["eggs florentine", "vegetarian breakfast", "poached eggs", "spinach eggs", "breakfast recipe"],
    amazonProducts: [
      {
        title: "Microplane Graters",
        description: "For perfectly grated nutmeg and other spices",
        link: "https://www.amazon.com/s?k=Microplane+Grater+Premium+Classic"
      },
      {
        title: "Egg Poaching Tools",
        description: "Professional equipment for poached eggs",
        link: "https://www.amazon.com/s?k=Egg+Poaching+Cups+Professional"
      },
      {
        title: "Slotted Spoons",
        description: "Essential tools for poached eggs",
        link: "https://www.amazon.com/s?k=Professional+Slotted+Spoon+Kitchen"
      }
    ]
  },
  {
    id: 8,
    title: "Shakshuka (Eggs in Tomato Sauce)",
    slug: "shakshuka",
    description: "A flavorful Middle Eastern breakfast dish with eggs poached in a spiced tomato and pepper sauce.",
    image: "https://images.pexels.com/photos/691077/pexels-photo-691077.jpeg",
    prepTime: "10 mins",
    cookTime: "25 mins",
    servings: 4,
    ingredients: [
      "6 large eggs",
      "2 tablespoons olive oil",
      "1 medium onion, diced",
      "1 red bell pepper, seeded and diced",
      "3 garlic cloves, minced",
      "1 teaspoon ground cumin",
      "1 teaspoon paprika",
      "1/2 teaspoon cayenne pepper (adjust to taste)",
      "1 can (28 oz) crushed tomatoes",
      "1/2 cup water",
      "Salt and freshly ground pepper",
      "Fresh chopped parsley or cilantro",
      "Crumbled feta cheese (optional)",
      "Warm pita bread or crusty bread for serving"
    ],
    instructions: [
      "Heat olive oil in a large, deep skillet over medium heat.",
      "Add onions and cook until softened, about 5-7 minutes.",
      "Add garlic and cook for another minute until fragrant.",
      "Stir in cumin, paprika, and cayenne pepper, cooking for 30 seconds to toast the spices.",
      "Add crushed tomatoes and water, season with salt and pepper.",
      "Simmer for 10-15 minutes, stirring occasionally, until the sauce thickens slightly.",
      "Using a spoon, make 6 wells in the sauce for the eggs.",
      "Crack an egg into each well, taking care not to break the yolks.",
      "Cover the skillet and cook for 5-8 minutes until egg whites are set but yolks are still runny.",
      "Garnish with parsley and serve hot with warm bread."
    ],
    tips: "For an extra flavor boost, add 1 teaspoon of smoked paprika or 1/2 teaspoon of ground coriander to the spice mixture. This dish is traditionally served in the pan it's cooked in.",
    keywords: ["shakshuka", "eggs in tomato sauce", "middle eastern breakfast", "one-pan meal", "breakfast eggs"],
    amazonProducts: [
      {
        title: "Cast Iron Skillets",
        description: "Perfect for cooking shakshuka",
        link: "https://www.amazon.com/s?k=Cast+Iron+Skillet+Large+Deep"
      },
      {
        title: "Middle Eastern Spice Sets",
        description: "Essential spices for authentic shakshuka",
        link: "https://www.amazon.com/s?k=Middle+Eastern+Spice+Set+Cooking"
      },
      {
        title: "Serving Bowls",
        description: "Beautiful bowls for serving shakshuka",
        link: "https://www.amazon.com/s?k=Shallow+Serving+Bowls+Set"
      }
    ]
  },
  {
    id: 9,
    title: "Egg Fried Rice",
    slug: "egg-fried-rice",
    description: "A quick and satisfying Asian-inspired dish that transforms leftover rice into a delicious meal with scrambled eggs and vegetables.",
    image: "https://images.pexels.com/photos/28503587/pexels-photo-28503587.jpeg",
    prepTime: "10 mins",
    cookTime: "15 mins",
    servings: 4,
    ingredients: [
      "4 large eggs, beaten",
      "3 cups cooked and chilled rice (preferably day-old)",
      "2 tablespoons vegetable oil, divided",
      "1 medium onion, diced",
      "2 carrots, diced",
      "1/2 cup frozen peas, thawed",
      "3 green onions, thinly sliced",
      "2 cloves garlic, minced",
      "1 tablespoon ginger, minced",
      "3 tablespoons soy sauce",
      "1 tablespoon sesame oil",
      "1/2 teaspoon white pepper",
      "Salt to taste"
    ],
    instructions: [
      "Break up any clumps in the cold rice with your fingers.",
      "Heat 1 tablespoon of oil in a large wok or skillet over high heat.",
      "Add beaten eggs and scramble quickly until just set but still moist, about 30 seconds.",
      "Remove eggs to a plate and set aside.",
      "Add remaining oil to the wok and heat until almost smoking.",
      "Add onion, carrots, and garlic, stir-frying for 2-3 minutes until softened.",
      "Add ginger and cook for 30 seconds until fragrant.",
      "Add the cold rice, breaking up any clumps with a spatula.",
      "Stir-fry for 3-4 minutes until rice is heated through and starting to crisp.",
      "Add peas and stir to combine.",
      "Return the scrambled eggs to the wok and break into smaller pieces.",
      "Drizzle with soy sauce and sesame oil, stirring to coat evenly.",
      "Season with white pepper and salt to taste.",
      "Toss in most of the green onions, reserving some for garnish.",
      "Serve hot, garnished with remaining green onions."
    ],
    tips: "Using day-old cold rice is crucial - fresh rice is too moist and will result in soggy fried rice. For authentic flavor, cook in a wok over high heat and keep the ingredients moving constantly.",
    keywords: ["egg fried rice", "chinese fried rice", "asian recipe", "leftover rice recipe", "quick dinner"],
    amazonProducts: [
      {
        title: "Carbon Steel Woks",
        description: "Traditional woks for perfect fried rice",
        link: "https://www.amazon.com/s?k=Carbon+Steel+Wok+Traditional"
      },
      {
        title: "Wok Utensils",
        description: "Essential tools for wok cooking",
        link: "https://www.amazon.com/s?k=Wok+Spatula+Traditional+Chinese"
      },
      {
        title: "Asian Sauce Sets",
        description: "Premium Asian cooking sauces",
        link: "https://www.amazon.com/s?k=Premium+Asian+Cooking+Sauce+Set"
      }
    ]
  },
  {
    id: 10,
    title: "Japanese Tamagoyaki (Rolled Omelette)",
    slug: "japanese-tamagoyaki",
    description: "A sweet and savory Japanese rolled omelette that's perfect for breakfast, bento boxes, or as a side dish.",
    image: "https://images.pexels.com/photos/6294359/pexels-photo-6294359.jpeg",
    prepTime: "10 mins",
    cookTime: "15 mins",
    servings: 2,
    ingredients: [
      "4 large eggs",
      "2 tablespoons dashi stock or water",
      "1 tablespoon mirin",
      "1 tablespoon soy sauce",
      "1 teaspoon sugar",
      "1/4 teaspoon salt",
      "Vegetable oil for cooking",
      "Optional: nori seaweed strips"
    ],
    instructions: [
      "Beat eggs in a bowl until well combined but not overly frothy.",
      "Mix dashi, mirin, soy sauce, sugar, and salt in a separate bowl until sugar dissolves.",
      "Combine egg mixture with seasoning mixture, strain through a fine sieve.",
      "Heat rectangular tamagoyaki pan over medium heat, oil lightly.",
      "Pour a thin layer of egg mixture, let it set slightly.",
      "Start rolling from one end when the surface is still slightly wet.",
      "Oil the pan again, pour another layer, lift the roll to let new egg flow underneath.",
      "Continue rolling and adding layers until all egg mixture is used.",
      "Cook until golden brown on all sides.",
      "Let cool slightly before slicing into thick pieces.",
      "Serve with grated daikon radish if desired."
    ],
    tips: "Use a rectangular tamagoyaki pan for best results, but a regular non-stick pan can work too. The key is to roll the omelette while the top is still slightly wet.",
    keywords: ["japanese cuisine", "tamagoyaki", "rolled omelette", "breakfast", "bento"],
    amazonProducts: [
      {
        title: "Tamagoyaki Pans",
        description: "Traditional pans for Japanese omelettes",
        link: "https://www.amazon.com/s?k=Tamagoyaki+Pan+Japanese+Omelette"
      }
    ]
  },
  {
    id: 11,
    title: "Turkish Menemen (Scrambled Eggs with Tomatoes)",
    slug: "turkish-menemen",
    description: "A traditional Turkish breakfast dish featuring eggs scrambled with tomatoes, peppers, and spices.",
    image: "https://images.pexels.com/photos/17198886/pexels-photo-17198886.jpeg",
    prepTime: "10 mins",
    cookTime: "20 mins",
    servings: 4,
    ingredients: [
      "6 large eggs",
      "3 medium tomatoes, diced",
      "2 green peppers, diced",
      "1 onion, finely chopped",
      "2 tablespoons olive oil",
      "1 teaspoon red pepper flakes",
      "Salt and black pepper to taste",
      "Fresh parsley for garnish",
      "Turkish bread (simit or pide) for serving"
    ],
    instructions: [
      "Heat olive oil in a large pan over medium heat.",
      "Add onions and cook until softened, about 5 minutes.",
      "Add green peppers and cook for another 3-4 minutes.",
      "Add diced tomatoes, red pepper flakes, salt, and pepper.",
      "Cook until tomatoes break down and release their juices, about 5-7 minutes.",
      "Beat eggs lightly in a bowl.",
      "Pour eggs over the tomato mixture.",
      "Gently stir occasionally until eggs are just set but still creamy.",
      "Garnish with parsley and serve hot with Turkish bread."
    ],
    tips: "Don't overcook the eggs - they should remain slightly creamy. Serve immediately while hot.",
    keywords: ["turkish breakfast", "menemen", "scrambled eggs", "mediterranean cuisine"],
    amazonProducts: [
      {
        title: "Traditional Turkish Cookware",
        description: "Authentic pans perfect for cooking menemen",
        link: "https://www.amazon.com/s?k=Turkish+Copper+Pan+Traditional+Cooking"
      },
      {
        title: "Mediterranean Spice Set",
        description: "Essential spices for Turkish cuisine",
        link: "https://www.amazon.com/s?k=Mediterranean+Turkish+Spice+Set"
      },
      {
        title: "Serving Plates Set",
        description: "Beautiful plates for serving Turkish breakfast",
        link: "https://www.amazon.com/s?k=Turkish+Breakfast+Serving+Plates"
      }
    ]
  },
  {
    id: 12,
    title: "Cloud Eggs (Eggs in Clouds)",
    slug: "cloud-eggs",
    description: "A whimsical breakfast dish where egg whites are whipped into fluffy clouds with the yolk nestled in the center.",
    image: "https://images.pexels.com/photos/31797093/pexels-photo-31797093.jpeg",
    prepTime: "15 mins",
    cookTime: "10 mins",
    servings: 4,
    ingredients: [
      "4 large eggs, separated",
      "1/4 cup grated Parmesan cheese",
      "2 tablespoons chopped fresh chives",
      "1/4 teaspoon salt",
      "1/8 teaspoon black pepper",
      "Optional: crispy bacon bits",
      "Toast for serving"
    ],
    instructions: [
      "Preheat oven to 450°F (230°C). Line a baking sheet with parchment paper.",
      "Carefully separate eggs, placing whites in a large bowl and yolks in individual small bowls.",
      "Beat egg whites with salt until soft peaks form.",
      "Fold in Parmesan cheese, chives, and pepper gently.",
      "Create 4 cloud-shaped mounds of egg white mixture on the baking sheet.",
      "Make a well in the center of each mound.",
      "Bake for 3 minutes until whites start to set.",
      "Carefully place a yolk in each well.",
      "Return to oven and bake for 3-4 minutes more until yolks reach desired doneness.",
      "Garnish with additional chives and serve immediately with toast."
    ],
    tips: "Make sure your bowl and beaters are completely clean and free from any grease for the best egg white peaks.",
    keywords: ["cloud eggs", "breakfast eggs", "fancy eggs", "egg whites", "brunch"],
    amazonProducts: [
      {
        title: "Stand Mixers",
        description: "Professional mixers for perfect egg whites",
        link: "https://www.amazon.com/s?k=Stand+Mixer+Professional+Kitchen"
      },
      {
        title: "Baking Sheet Sets",
        description: "Quality baking sheets for cloud eggs",
        link: "https://www.amazon.com/s?k=Professional+Baking+Sheet+Set"
      },
      {
        title: "Egg Separator Tools",
        description: "Tools for easily separating egg whites",
        link: "https://www.amazon.com/s?k=Egg+Separator+Tool+Professional"
      }
    ]
  },
  {
    id: 13,
    title: "Chinese Tea Eggs",
    slug: "chinese-tea-eggs",
    description: "Beautiful marbled eggs flavored with tea, soy sauce, and spices, popular in Chinese cuisine.",
    image: "https://images.pexels.com/photos/8329969/pexels-photo-8329969.jpeg",
    prepTime: "15 mins",
    cookTime: "2 hrs",
    servings: 6,
    ingredients: [
      "6 large eggs",
      "2 black tea bags",
      "1/4 cup soy sauce",
      "2 star anise pods",
      "1 cinnamon stick",
      "2 tablespoons dark soy sauce",
      "1 teaspoon sugar",
      "1 tablespoon Sichuan peppercorns",
      "2 strips orange peel",
      "Water for boiling"
    ],
    instructions: [
      "Place eggs in a pot and cover with cold water. Bring to a boil.",
      "Reduce heat and simmer for 7 minutes.",
      "Remove eggs and place in ice water bath.",
      "Once cool, gently crack the eggshells all over but do not peel.",
      "In the same pot, combine 4 cups water, tea bags, both soy sauces, and all spices.",
      "Bring the mixture to a boil, then reduce heat to low.",
      "Add the cracked eggs back to the pot.",
      "Simmer for 2-3 hours, longer for stronger flavor.",
      "Remove eggs, peel, and serve warm or cold."
    ],
    tips: "The longer you let the eggs simmer in the tea mixture, the more intense the flavor and marbling pattern will be.",
    keywords: ["chinese cuisine", "tea eggs", "marbled eggs", "asian cuisine", "snack"],
    amazonProducts: [
      {
        title: "Chinese Cooking Pots",
        description: "Traditional pots for tea eggs",
        link: "https://www.amazon.com/s?k=Chinese+Cooking+Pot+Traditional"
      },
      {
        title: "Chinese Tea and Spice Sets",
        description: "Authentic spices for tea eggs",
        link: "https://www.amazon.com/s?k=Chinese+Tea+Spice+Set+Cooking"
      },
      {
        title: "Asian Sauce Collection",
        description: "Premium soy sauces for authentic flavor",
        link: "https://www.amazon.com/s?k=Premium+Asian+Soy+Sauce+Set"
      }
    ]
  },
  {
    id: 14,
    title: "Eggs en Cocotte (Baked Eggs)",
    slug: "eggs-en-cocotte",
    description: "Elegant French-style baked eggs with cream and herbs, served in individual ramekins.",
    image: "https://images.pexels.com/photos/6294391/pexels-photo-6294391.jpeg",
    prepTime: "10 mins",
    cookTime: "15 mins",
    servings: 4,
    ingredients: [
      "8 large eggs",
      "8 tablespoons heavy cream",
      "4 tablespoons butter",
      "Fresh herbs (chives, parsley, tarragon)",
      "Salt and freshly ground pepper",
      "Nutmeg, freshly grated",
      "4 slices prosciutto or ham (optional)",
      "Toasted bread for serving"
    ],
    instructions: [
      "Preheat oven to 375°F (190°C). Bring a kettle of water to boil.",
      "Butter four ramekins generously.",
      "If using, line each ramekin with a slice of prosciutto.",
      "Crack 2 eggs into each ramekin.",
      "Add 2 tablespoons cream to each ramekin.",
      "Season with salt, pepper, and a pinch of nutmeg.",
      "Sprinkle with chopped herbs.",
      "Place ramekins in a baking dish.",
      "Pour hot water into the baking dish halfway up the sides of the ramekins.",
      "Bake for 12-15 minutes until whites are set but yolks are still runny.",
      "Serve immediately with toasted bread."
    ],
    tips: "Watch the eggs carefully while baking - they can go from perfectly cooked to overdone very quickly.",
    keywords: ["french cuisine", "baked eggs", "eggs en cocotte", "breakfast", "brunch"],
    amazonProducts: [
      {
        title: "Ramekin Sets",
        description: "Perfect ramekins for eggs en cocotte",
        link: "https://www.amazon.com/s?k=Porcelain+Ramekins+Set+Baking"
      },
      {
        title: "Baking Dishes",
        description: "Water bath dishes for perfect baked eggs",
        link: "https://www.amazon.com/s?k=Glass+Baking+Dish+Water+Bath"
      },
      {
        title: "French Cookware",
        description: "Classic French bakeware collection",
        link: "https://www.amazon.com/s?k=French+Bakeware+Set+Professional"
      }
    ]
  },
  {
    id: 15,
    title: "Sous Vide Egg Bites",
    slug: "sous-vide-egg-bites",
    description: "Creamy, perfectly cooked egg bites inspired by Starbucks, made using the sous vide technique for an incredibly smooth texture.",
    image: "https://images.pexels.com/photos/31882544/pexels-photo-31882544.jpeg",
    prepTime: "15 mins",
    cookTime: "60 mins",
    servings: 6,
    ingredients: [
      "6 large eggs",
      "1/2 cup cottage cheese",
      "1/2 cup Gruyere cheese, grated",
      "1/4 cup heavy cream",
      "1/4 teaspoon salt",
      "1/8 teaspoon black pepper",
      "Optional fillings:",
      "Crispy bacon bits",
      "Roasted red peppers, diced",
      "Baby spinach, chopped",
      "Fresh herbs (chives, basil, or parsley)"
    ],
    instructions: [
      "Set sous vide circulator to 172°F (77.8°C).",
      "Blend eggs, cottage cheese, cream, salt, and pepper until very smooth.",
      "Grease small mason jars or silicone egg molds.",
      "Fill each jar about 3/4 full with egg mixture.",
      "Add desired fillings and Gruyere cheese to each jar.",
      "Seal jars finger-tight (not too tight) if using mason jars.",
      "Lower jars into preheated water bath.",
      "Cook for 60 minutes until eggs are set but still creamy.",
      "Remove from water bath and let cool slightly.",
      "Run a knife around the edge and unmold if using silicone molds.",
      "Serve warm, garnished with fresh herbs."
    ],
    tips: "For the smoothest texture, blend the egg mixture really well and strain through a fine-mesh sieve before cooking. These can be made ahead and reheated gently in the microwave.",
    keywords: ["sous vide eggs", "egg bites", "breakfast", "meal prep", "starbucks copycat"],
    amazonProducts: [
      {
        title: "Sous Vide Circulators",
        description: "Professional sous vide equipment for perfect egg bites",
        link: "https://www.amazon.com/s?k=Sous+Vide+Precision+Cooker"
      },
      {
        title: "Silicone Egg Bite Molds",
        description: "Specially designed molds for egg bites",
        link: "https://www.amazon.com/s?k=Silicone+Egg+Bite+Molds"
      },
      {
        title: "Mason Jars",
        description: "Perfect size jars for sous vide cooking",
        link: "https://www.amazon.com/s?k=Small+Mason+Jars+4oz"
      }
    ]
  },
  {
    id: 16,
    title: "Japanese Souffle Pancakes",
    slug: "japanese-souffle-pancakes",
    description: "Light and jiggly Japanese-style pancakes made with whipped egg whites, topped with a perfectly cooked egg yolk.",
    image: "https://images.pexels.com/photos/20109559/pexels-photo-20109559.jpeg",
    prepTime: "20 mins",
    cookTime: "15 mins",
    servings: 3,
    ingredients: [
      "2 large eggs, separated",
      "1/4 cup milk",
      "1 teaspoon vanilla extract",
      "1/2 cup cake flour",
      "1 1/2 teaspoons baking powder",
      "3 tablespoons sugar",
      "Pinch of salt",
      "Butter for cooking",
      "For serving:",
      "3 fresh egg yolks",
      "Maple syrup",
      "Fresh berries",
      "Whipped cream"
    ],
    instructions: [
      "Whisk egg yolks with milk and vanilla until smooth.",
      "Sift together cake flour and baking powder.",
      "In a separate bowl, beat egg whites with sugar until stiff peaks form.",
      "Fold flour mixture into egg yolk mixture.",
      "Gently fold in egg whites in three additions.",
      "Heat a non-stick pan over very low heat.",
      "Grease pan and ring molds with butter.",
      "Pour batter into 3-inch ring molds, filling 3/4 full.",
      "Cover and cook for 4-5 minutes.",
      "Flip carefully and cook another 4-5 minutes.",
      "Meanwhile, prepare onsen tamago (slow-cooked egg) for topping.",
      "Serve pancakes topped with egg yolk, syrup, and garnishes."
    ],
    tips: "Temperature control is crucial - keep the heat very low to achieve the signature height and prevent burning. Use ring molds for the perfect shape.",
    keywords: ["japanese pancakes", "souffle pancakes", "fluffy pancakes", "breakfast", "brunch"],
    amazonProducts: [
      {
        title: "Pancake Ring Molds",
        description: "Essential for perfect round pancakes",
        link: "https://www.amazon.com/s?k=Pancake+Ring+Molds+Professional"
      },
      {
        title: "Electric Hand Mixers",
        description: "For perfectly whipped egg whites",
        link: "https://www.amazon.com/s?k=Electric+Hand+Mixer+Professional"
      },
      {
        title: "Non-Stick Pancake Pan",
        description: "Specialized pan for perfect pancakes",
        link: "https://www.amazon.com/s?k=Non+Stick+Pancake+Pan+Professional"
      }
    ]
  },
  {
    id: 17,
    title: "Korean Steamed Eggs (Gyeran Jjim)",
    slug: "korean-steamed-eggs",
    description: "A silky smooth Korean steamed egg dish that's both comforting and elegant, perfect as a side dish or light meal.",
    image: "https://images.pexels.com/photos/19955959/pexels-photo-19955959.jpeg",
    prepTime: "10 mins",
    cookTime: "15 mins",
    servings: 4,
    ingredients: [
      "4 large eggs",
      "1 cup warm water or anchovy stock",
      "1 green onion, finely chopped",
      "1 teaspoon sesame oil",
      "1/4 teaspoon salt",
      "1/8 teaspoon white pepper",
      "Optional garnishes:",
      "Toasted sesame seeds",
      "Chili oil",
      "Extra chopped green onions"
    ],
    instructions: [
      "Beat eggs in a bowl until well combined.",
      "Strain eggs through a fine-mesh sieve for smoothness.",
      "Gradually stir in warm water or stock.",
      "Add salt and white pepper.",
      "Pour mixture into a heat-safe ceramic bowl.",
      "Place bowl in a steamer or pot with water.",
      "Cover and steam over medium-low heat for 10-12 minutes.",
      "Check consistency - should be barely set and silky.",
      "Drizzle with sesame oil.",
      "Garnish with green onions and optional toppings.",
      "Serve immediately while hot and custardy."
    ],
    tips: "The key to silky smooth steamed eggs is straining the mixture and maintaining steady, gentle heat. Don't let the water boil too vigorously.",
    keywords: ["korean cuisine", "steamed eggs", "gyeran jjim", "asian breakfast", "comfort food"],
    amazonProducts: [
      {
        title: "Korean Earthenware Bowls",
        description: "Traditional bowls for steamed eggs",
        link: "https://www.amazon.com/s?k=Korean+Stone+Bowl+Cooking"
      },
      {
        title: "Bamboo Steamer Sets",
        description: "Perfect for gentle steaming",
        link: "https://www.amazon.com/s?k=Bamboo+Steamer+Set+Cooking"
      },
      {
        title: "Fine Mesh Strainers",
        description: "For perfectly smooth eggs",
        link: "https://www.amazon.com/s?k=Fine+Mesh+Strainer+Professional"
      }
    ]
  },
  {
    id: 18,
    title: "Spring Vegetable Frittata",
    slug: "spring-vegetable-frittata",
    description: "A beautiful open-faced Italian omelette packed with fresh spring vegetables and creamy goat cheese.",
    image: "https://images.pexels.com/photos/14302153/pexels-photo-14302153.jpeg",
    prepTime: "15 mins",
    cookTime: "20 mins",
    servings: 6,
    ingredients: [
      "8 large eggs",
      "1/4 cup heavy cream",
      "1 cup asparagus, trimmed and cut into 2-inch pieces",
      "1 cup fresh peas",
      "1 leek, cleaned and thinly sliced",
      "2 cups baby spinach",
      "4 oz goat cheese, crumbled",
      "2 tablespoons fresh herbs (chives, dill, tarragon)",
      "2 tablespoons olive oil",
      "Salt and freshly ground pepper",
      "Zest of 1 lemon"
    ],
    instructions: [
      "Preheat oven to 375°F (190°C).",
      "Whisk eggs with cream, salt, pepper, and lemon zest.",
      "Heat olive oil in an oven-safe skillet over medium heat.",
      "Sauté leeks until softened, about 3-4 minutes.",
      "Add asparagus and peas, cook for 2-3 minutes.",
      "Add spinach and cook until just wilted.",
      "Pour in egg mixture and scatter goat cheese on top.",
      "Cook on stovetop for 5 minutes until edges start to set.",
      "Transfer to oven and bake for 10-12 minutes until center is set.",
      "Sprinkle with fresh herbs before serving.",
      "Serve warm or at room temperature."
    ],
    tips: "Don't overcook the frittata - it should be just set in the center and slightly puffed. It will continue to cook slightly after removing from the oven.",
    keywords: ["frittata", "vegetarian", "spring recipe", "brunch", "italian cuisine"],
    amazonProducts: [
      {
        title: "Cast Iron Skillets",
        description: "Oven-safe skillets for perfect frittatas",
        link: "https://www.amazon.com/s?k=Cast+Iron+Skillet+Oven+Safe"
      },
      {
        title: "Microplane Zesters",
        description: "For perfect lemon zest",
        link: "https://www.amazon.com/s?k=Microplane+Zester+Premium"
      },
      {
        title: "Mixing Bowl Sets",
        description: "Professional bowls for egg preparation",
        link: "https://www.amazon.com/s?k=Glass+Mixing+Bowl+Set+Professional"
      }
    ]
  }
];